// src/app/app.module.ts
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { MainLayoutComponent } from './components/layout/main-layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { PatientsComponent } from './components/patients/patients.component';
import { ProfessionalsComponent } from './components/professionals/professionals.component';
import { MedicalRecordsComponent } from './components/medical-records/medical-records.component';

// Financial Module Components
import { SuppliersComponent } from './components/suppliers/suppliers.component';
import { AccountCategoriesComponent } from './components/account-categories/account-categories.component';
import { CostCentersComponent } from './components/cost-centers/cost-centers.component';
import { BankAccountsComponent } from './components/bank-accounts/bank-accounts.component';
import { HealthInsurancesComponent } from './components/health-insurances/health-insurances.component';
import { AccountsReceivableComponent } from './components/accounts-receivable/accounts-receivable.component';
import { AccountsPayableComponent } from './components/accounts-payable/accounts-payable.component';

import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PaginationComponent } from './shared/pagination/pagination.component';
import { NotificationComponent } from './components/notification/notification.component';
import { LoadingSpinnerComponent } from './components/shared/loading-spinner/loading-spinner.component';
import { IconColorDirective } from './directives/icon-color.directive';

// Registrar locale pt-BR
registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    MainLayoutComponent,
    DashboardComponent,
    AgendaComponent,
    PatientsComponent,
    ProfessionalsComponent,
    MedicalRecordsComponent,
    PaginationComponent,
    NotificationComponent,
    LoadingSpinnerComponent,
    IconColorDirective,
    // Financial Module Components
    SuppliersComponent,
    AccountCategoriesComponent,
    CostCentersComponent,
    BankAccountsComponent,
    HealthInsurancesComponent,
    AccountsReceivableComponent,
    AccountsPayableComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
